module.exports = __webpack_public_path__ + "img/exam.76b50e2f.svg";